module.exports = __webpack_public_path__ + "img/1.cfed9b8e.png";